<template>
  <div
    v-loading="loading"
    class="wx-conversation"
  >
    <div class="container">
      <div class="search-state">
        <mk-select
          v-model="agentId"
          placeholder="请选择"
          width="200"
          class="mr"
          @change="agentChange"
        >
          <mk-option
            v-for="item in wxListData"
            :key="item.M7Agent"
            :label="item.M7AgentNick"
            :value="item.M7Agent"
          >
          </mk-option>
        </mk-select>
        <mk-date-picker
          v-model="time"
          type="daterange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          class="range-picker mr"
        >
        </mk-date-picker>
        <mk-input
          v-model="content"
          class="mr"
          width="180"
          placeholder="输入聊天内容"
        ></mk-input>
        <div class="btn-group">
          <mk-button-biz
            type="primary"
            @click="search(1, true)"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz @click="reset">
            重置
          </mk-button-biz>
        </div>
      </div>
      <div class="div-conversation">
        <wechat-record
          :chat-data="chatData"
          :over-total="overTotal"
          :is-search="isSearch"
          :page="pageNum"
          @loadMore="loadMore"
        ></wechat-record>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import WechatRecord from '@/components/wechat-record'
const start = new Date()
const now = new Date()
const defaultDate = [
  new Date(start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)),
  now
]
export default {
  name: 'WxConversation',
  components: {
    WechatRecord
  },
  props: {
    // 当前好友的信息
    friendData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 是否在加载中
      loading: false,
      // 聊天记录
      chatData: {},
      // 时间选择器的值 默认一个月
      time: [...defaultDate],
      // 聊天内容搜索
      content: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // 当前页码
      pageNum: 1,
      // 剩余消息条数
      overTotal: 0,
      // 是否是搜索
      isSearch: false,
      // 当前坐席微信号arr
      wxListData: [],
      // 当前坐席微信agentId
      agentId: '',
      // 好友id
      friendId: ''
    }
  },
  mounted () {
    this.wxcontactWechatContactGet()
  },
  methods: {
    // 加载更多
    loadMore () {
      ++this.pageNum
      this.isSearch = false
      this.search()
    },
    // 根据这个人的微信号获取这个人的详细信息
    async wxcontactWechatContactGet () {
      if (!this.friendData.m7WxNo) {
        this.$emit('getFriendInfo', [])
        this.$message.error('查询错误')
        return
      }
      this.loading = true
      let res = await BIZAPIS.WechatContactApi.wxcontactWechatContactGet({
        wxNo: this.friendData.m7WxNo
      })
      this.loading = false
      if (res.success) {
        this.wxListData = res.data
        this.agentId = res.data[0].M7Agent
        this.friendId = res.data[0].M7Id
        this.$emit('getFriendInfo', res.data)
        this.search(1)
      }
    },
    // 下拉框选择
    agentChange (val) {
      this.wxListData.forEach(item => {
        if (item.M7Agent === val) {
          this.friendId = item.M7Id
        }
      })
    },
    // 获取好友聊天记录
    async wxcontactRecordPost (data) {
      this.loading = true
      let res = await BIZAPIS.WechatContactApi.wxcontactRecordPost(data)
      this.loading = false
      if (res.success) {
        this.chatData = res.data ? res.data : {}
        this.overTotal = parseInt(res.data.count - this.pageNum * 20) || 0
      }
    },
    // 搜索
    search (page = this.pageNum, clickSearch) {
      const begin = this.time ? dayjs(this.time[0]).format('YYYY-MM-DD') : ''
      const end = this.time ? dayjs(this.time[1]).format('YYYY-MM-DD') : ''
      let params = {
        agent: this.agentId,
        begin,
        end,
        msgContent: this.content,
        page: page,
        pageSize: 20,
        _id: this.friendId
      }
      // 点击搜索时候需要清空聊天记录
      if (clickSearch) {
        this.isSearch = true
      }
      this.wxcontactRecordPost(params)
    },
    reset () {
      this.time = [...defaultDate]
      if (this.wxListData.length > 0) {
        this.agentId = this.wxListData[0].M7Agent
      }
      this.content = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wx-conversation {
  height: 100%;
  min-height: 400px;
  background-color: #fff;
  padding: 0 20px 10px 20px;
  overflow: hidden;
  box-sizing: border-box;

  .container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    background-color: #fff;
  }

  .search-state {
    display: flex;
    flex-wrap: wrap;

    .range-picker {
      height: 32px;

      /deep/ .el-range__icon {
        line-height: 24px;
      }

      /deep/ .el-range-separator {
        line-height: 24px;
      }

      /deep/ .el-range__close-icon {
        line-height: 24px;
      }
    }

    .mr {
      margin: 10px 10px 0 0;
    }

    .btn-group {
      // margin-left: 16px;
      margin-top: 10px;
    }
  }

  .div-conversation {
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-top: 10px;
    height: 100%;
    background: #f5f5f5;

    .wechat-record {
      /deep/ .chat-right {
        margin-right: 20px;
      }

      /deep/ .chat-left {
        margin-left: 20px;
      }
    }
  }
}
</style>
